import React from 'react'
import { Container, Wrapper, Header } from '../../components_renew/Layout'
import ImgBanner_haiou from '../../assets/haiou/tutorial-banner.png'
import ImgCard1_haiou from '../../assets/img/tutorial-card-1.png'
import ImgCard2_haiou from '../../assets/img/tutorial-card-2.png'
import ImgCard3_haiou from '../../assets/img/tutorial-card-3.png'
import ImgBanner_xiniu from '../../assets/xiniu/tutorial-banner.png'
import ImgCard1_xiniu from '../../assets/xiniu/tutorial-card-1.png'
import ImgCard2_xiniu from '../../assets/xiniu/tutorial-card-2.png'
import ImgCard3_xiniu from '../../assets/xiniu/tutorial-card-3.png'
import ImgCard_4 from '../../assets/youpin/tutorial-card-4.png'
import ImgBanner_xibei from '../../assets/xibei/tutorial-banner.png'
import ImgBanner_wanshun from '../../assets/wanshun/tutorial-banner.png'
import ImgBanner_youpin from '../../assets/youpin/tutorial-banner.png'
import ImgBanner_qxtj from '../../assets/qxtj/tutorial-banner.png'
import ImgBanner_qxyg from '../../assets/qxyg/tutorial-banner.png'
import ImgBanner_qxdg from '../../assets/qxdg/tutorial-banner.png'
import ImgBanner_tjyg from '../../assets/tjyg/tutorial-banner.jpg'
import ImgBanner_ytyg from '../../assets/hnyt/ytyg/tutorial_banner.jpg'
import ImgBanner_dyyg from '../../assets/hnyt/dyyg/tutorial_banner.jpg'
import base64url from 'base64url'

let ImgBanner = null
let ImgCard1 = null
let ImgCard2 = null
let ImgCard3 = null
let ImgCard4 = null
switch (process.env['REACT_APP_CHANNEL']) {
  case 'haiou':
    ImgBanner = ImgBanner_haiou
    ImgCard1 = ImgCard1_haiou
    ImgCard2 = ImgCard2_haiou
    ImgCard3 = ImgCard3_haiou
    break
  case 'ytyg':
    ImgBanner = ImgBanner_ytyg
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'dyyg':
    ImgBanner = ImgBanner_dyyg
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'youpin':
    ImgBanner = ImgBanner_youpin
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    ImgCard4 = ImgCard_4
    break
  case 'xiniu':
  case 'trading':
  case 'tradeasy':
    ImgBanner = ImgBanner_xiniu
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'xbyg':
  case 'xibei':
    ImgBanner = ImgBanner_xibei
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'wanshun':
    ImgBanner = ImgBanner_wanshun
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'qxyg':
    ImgBanner = ImgBanner_qxyg
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'qxtj':
    ImgBanner = ImgBanner_qxtj
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'qxdg':
    ImgBanner = ImgBanner_qxdg
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  case 'tjyg':
    ImgBanner = ImgBanner_tjyg
    ImgCard1 = ImgCard1_xiniu
    ImgCard2 = ImgCard2_xiniu
    ImgCard3 = ImgCard3_xiniu
    break
  default:
}
let Img = (props) => {
  return <img style={{ width: '100%', height: 'auto' }} alt='' {...props} />
}
const TITLE = '帮助中心'

class Home extends React.PureComponent {
  constructor (props) {
    super(props)
    document.title = TITLE
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.withHeader = urlParams.get('withHeader')
  }

  render () {
    return (process.env['REACT_APP_CHANNEL'] === 'haiou')
      ? <Container>
        {this.withHeader ? <Header>{TITLE}</Header> : null}
        <Wrapper>
          <br/>
          {/*<Img src={ImgBanner} onClick={this.onBannerClick}/>*/}
          <img src={ImgBanner}
               style={{ display: 'block', width: '95%', margin: 'auto' }} alt=''
               onClick={this.onBannerClick}/>
          <br/>
          <Img src={ImgCard1} onClick={this.goToList.bind(this, 1)}/>
          <Img src={ImgCard2} onClick={this.goToList.bind(this, 2)}/>
          <Img src={ImgCard3} onClick={this.goToList.bind(this, 3)}/>
        </Wrapper>
      </Container>
      : <Container>
        {this.withHeader ? <Header>{TITLE}</Header> : null}
        <Wrapper>
          {/*<Img src={ImgBanner} onClick={this.onBannerClick}/>*/}
          <img src={ImgBanner}
               style={{ display: 'block', width: '100%', margin: 'auto' }} alt=''
               onClick={this.onBannerClick}/>
          <br/>
          <div style={{padding: '1rem'}}><Img src={ImgCard1} onClick={this.goToList.bind(this, 1)}/></div>
          <div style={{padding: '1rem'}}><Img src={ImgCard2} onClick={this.goToList.bind(this, 2)}/></div>
          <div style={{padding: '1rem'}}><Img src={ImgCard3} onClick={this.goToList.bind(this, 3)}/></div>
          {
            ImgCard4? <div style={{padding: '1rem'}}><Img src={ImgCard4} onClick={this.toLink4}/></div> : null
          }
        </Wrapper>
      </Container>
  }

  goToList = type => {
    this.props.history.push(`${window.PATH.TUTORIAL_LIST}/${type}${this.withHeader ? '?withHeader=1' : ''}`)
  }
  toLink4 = () => {
    let url = ''
    switch (process.env['REACT_APP_CHANNEL']) {
      case 'youpin':
        // url = process.env['REACT_APP_BUILD_ENV'] === 'development' ? 'http://api.dev.hnqcwlkj.com/html/v1/article/html/63d409b7-17aa-46cb-8248-b6ca5498d61e': 'https://api.hnqcwlkj.com/html/v1/article/html/84690bea-9691-4650-a719-19fcf2fe8bfd'
        // link = process.env['REACT_APP_BUILD_ENV'] === 'development' ? 'http://cdn.dev.hnqcwlkj.com/1757400775615.jpeg': 'https://cdn.hnqcwlkj.com/1757920119479.png'
        url = 'https://cdn.hnqcwlkj.com/1757920119479.png'
        break
      default:
    }
    this.props.history.push(`${window.PATH.IMAGE_FRAME_BTN}/${base64url.encode(url)}${this.withHeader ? '?withHeader=1&btn=recharge' : '?btn=recharge'}`)
    // window.location = link
  }
  onBannerClick = () => {
    // window.location = 'http://api.mjsjs.cn/html/v1/article/html/664a67a2-9691-4ab7-9298-6f2677cccda8'
    switch (process.env['REACT_APP_CHANNEL']) {
      case 'wanshun':
        window.location = 'https://api.hnqcwlkj.com/html/v1/article/html/f53c02ee-8e65-44f3-b77a-57872e77597e'
        break
      case 'qxyg':
        window.location = 'https://api.hnjcwlkj.cn/html/v1/article/html/706addfc-33b9-46d8-939b-c9294d405b4d'
        break;
      case 'qxtj':
        window.location = 'https://api.hnjcwlkj.cn/html/v1/article/html/bbdaa68e-40f8-49f3-a6a1-55d985fcf706'
        break
      case 'qxdg':
        window.location = 'https://api.hnjcwlkj.cn/html/v1/article/html/c7a6f8a5-a086-46bd-a0d9-1d1bc7548795'
        break
      default:
        this.props.history.push(`${window.PATH.TUTORIAL_DETAILS}${this.withHeader ? '?withHeader=1' : ''}`)
    }
  }
}

export { Home }
